import React from 'react';

const PresentationAds = ({ data: { ads, title } }) => (
   ads.length > 0 ?
     <div>
       <p><b>{title}</b></p>
       <ul className="ads-list">
         {ads.map(ad => (<li>{ad.name}</li>))}
       </ul>
     </div>
   : null
)
export default PresentationAds;



// WEBPACK FOOTER //
// ./src/screens/Presentation/PresentationAds.js